module.exports = __webpack_public_path__ + "static/media/card-story-bg.4750d7d1.png";